import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';

const ProfilePage = () => {
  return (
    <Container fluid>
      <Row>
        <Col>
          <h1 className="h3 mb-4">Profil</h1>
          <Card>
            <Card.Body className="text-center py-5">
              <i className="fas fa-user text-muted mb-3" style={{ fontSize: '3rem' }}></i>
              <h5 className="text-muted">Profilseite</h5>
              <p className="text-muted">Diese Seite wird die Benutzerprofilinformationen und Einstellungen anzeigen.</p>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default ProfilePage;
